import React from 'react';
import { StyledTag } from './styled';

export const Tag = ({ padding, ...props }) => {
    return <StyledTag $padding={padding} {...props} />;
};
